module.exports = __webpack_public_path__ + "img/ico-interactive-platform_1.79f9efd3.svg";